var render = function render(_c,_vm){return _c('img',{key:'imageBasicCounter',attrs:{"src":require("assets/img/header/counter.webp"),"loading":"lazy","height":"42","width":"291","alt":_vm.props.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }